'use es6';

import { isSupportedCrmObject } from '../crmObjects/utils';
export const getDataType = report => isSupportedCrmObject(report.getIn(['config', 'dataType'])) ? report.getIn(['config', 'objectTypeId']) : report.getIn(['config', 'dataType']);